import http from "./httpService";
import jwtDecode from "jwt-decode";

const apiEndPoint = "/auth";

http.setJwt(getJwt());

export function getJwt() {
  return localStorage.getItem("token");
}

export async function login(email, password) {
  const { data } = await http.post(`${apiEndPoint}`, {
    email,
    password,
  });
  http.setJwt(data.token);
  localStorage.setItem("token", data.token);
}

export function loginWithJwt(jwt) {
  localStorage.setItem("token", jwt);
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("currentStore");
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem("token");
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export default {
  login,
  logout,
  getCurrentUser,
  loginWithJwt,
  getJwt,
};
